import React, { useEffect, useState } from "react";
import Avatar from "../../../../../assets/img/Anonymous.png";
import { copyToClipboard, mergeData } from "./utils";
function RenderTableData({ data, userData, externalUsers }) {
  const [copiedIndex, setCopiedIndex] = useState(null);
  const [mergedData, setMergedData] = useState([]);

  useEffect(() => {
    mergeData(externalUsers, setMergedData, data);
  }, [externalUsers, data]);
  return (
    <>
      {mergedData.map((polaznik, index) => (
        <tr
          key={index}
          onClick={
            userData.roleId === 6
              ? () =>
                  copyToClipboard(
                    data,
                    polaznik.firstName,
                    polaznik.lastName,
                    polaznik.emailAddress,
                    setCopiedIndex
                  )
              : null
          }
          style={{
            cursor: userData.roleId === 6 ? "pointer" : "default",
          }}
        >
          <td style={{ color: "#2E3646", padding: "20px 12px" }}>
            <div className="table-polaznici-row">{index + 1}.</div>
          </td>
          <td style={{ color: "#2E3646" }}>
            <div
              className="table-polaznici-row"
              style={{ fontWeight: copiedIndex === index ? "800" : "" }}
            >
              <div className="table-polaznici-avatar">
                <img
                  alt=""
                  src={polaznik.imageUrl ? polaznik.imageUrl : Avatar}
                />
              </div>
              {polaznik.firstName ? polaznik.firstName : "Vanjski"}{" "}
              {polaznik.lastName ? polaznik.lastName : "sudionik"}
            </div>
          </td>
          <td style={{ color: "#5F6D7E" }}>
            {polaznik.aktivniProgramResponse.length > 0 ? (
              <div className="table-polaznici-column">
                {polaznik.aktivniProgramResponse[0] && (
                  <>
                    <p style={{ marginBlockEnd: 5, marginBlockStart: 5 }}>
                      {polaznik.aktivniProgramResponse[0].title}
                    </p>
                    <p style={{ marginBlockEnd: 5, marginBlockStart: 5 }}>
                      {polaznik.aktivniProgramResponse[0].name}
                    </p>
                  </>
                )}
              </div>
            ) : (
              "Nema podataka"
            )}
          </td>
          {userData.roleId === 6 && (
            <td style={{ color: "#5F6D7E" }}>
              <div
                className=""
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyItems: "flex-start",
                  fontWeight: copiedIndex === index ? "800" : "",
                }}
              >
                {polaznik.emailAddress ? (
                  <p>{polaznik.emailAddress}</p>
                ) : (
                  "Nema podataka"
                )}
              </div>
            </td>
          )}
        </tr>
      ))}
    </>
  );
}

export default RenderTableData;
